// extracted by mini-css-extract-plugin
export default {"container":"TaxList_container__4vmFS","noResults":"TaxList_noResults__nfYCS"};